interface HeroProps {
    onPurchase: () => void;
    isLoading: boolean;
}

const Hero: React.FC<HeroProps> = ({ onPurchase, isLoading }) => {
    return (
        <section className="bg-black text-white pt-16 pb-12 px-4">
            <div className="max-w-4xl mx-auto text-center">

                {/* Badge minimalista */}
                <div className="inline-block bg-cyan-400/10 border border-cyan-400/30 rounded-full px-4 py-1 mb-6">
                    <span className="text-cyan-400 text-xs font-bold uppercase tracking-widest">
                        🚀 Launch Offer · $9.99 (70% OFF)
                    </span>
                </div>

                {/* Título más potente */}
                {/* Versión móvil - sin <br /> */}
                <h1 className="sm:hidden text-4xl font-extrabold mb-6 leading-tight tracking-tight">
                    Grow on X fast and get
                    <span className="text-cyan-400"> real users for your SaaS</span>
                </h1>

                {/* Versión desktop - con <br /> */}
                <h1 className="hidden sm:block text-4xl md:text-6xl font-extrabold mb-6 leading-tight tracking-tight">
                    Grow on X fast and get <br />
                    <span className="text-cyan-400">real users for your SaaS</span>
                </h1>

                {/* Tu historia en 2 líneas */}
                <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-10 max-w-2xl mx-auto">
                    <img
                        src="/images/eliana-boat-3.png"
                        alt="Eliana"
                        className="w-20 h-20 md:w-24 md:h-24 object-cover rounded-full border-2 border-cyan-400 shadow-[0_0_15px_rgba(34,211,238,0.3)]"
                    />
                    <div className="text-left">
                        <p className="text-lg text-gray-200 leading-snug">
                            <strong>I'm Eliana.</strong> Scuba instructor turned indie hacker. I went from <strong>0 to 15k followers</strong> in 10 months without gimmicks. This is the exact playbook I use to drive SaaS signups and land paid collabs.
                        </p>
                    </div>
                </div>

                {/* CTA Principal */}
                <div className="flex flex-col items-center">
                    <button
                        onClick={onPurchase}
                        disabled={isLoading}
                        className={`bg-cyan-400 hover:bg-cyan-300 text-black font-bold py-4 px-12 rounded-full text-xl transition-all hover:scale-105 shadow-lg shadow-cyan-400/20 ${isLoading ? "opacity-60 cursor-not-allowed" : ""
                            }`}
                    >
                        {isLoading ? "Processing..." : "Get the Playbook — $9.99"}
                    </button>

                    <p className="text-sm text-gray-400 mt-4">
                        <span className="line-through opacity-50">$29.99</span> · Instant Access · 45-page No-Fluff PDF
                    </p>
                </div>

                {/* Lo que obtienen (Resumen rápido) */}
                <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 text-left border-t border-zinc-800 pt-10 text-lg">
                    <div>
                        <h3 className="text-cyan-400 font-bold mb-1">Growth System</h3>
                        <p className="sm:text-md text-sm text-gray-400">Viral hooks and content formulas that actually work.</p>
                    </div>
                    <div>
                        <h3 className="text-cyan-400 font-bold mb-1">Conversion</h3>
                        <p className="sm:text-md text-sm text-gray-400">How to turn followers into active users for your SaaS.</p>
                    </div>
                    <div>
                        <h3 className="text-cyan-400 font-bold mb-1">Monetization</h3>
                        <p className="sm:text-md text-sm text-gray-400">Tactics to land paid collaborations and revenue.</p>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default Hero;

// interface HeroProps {
//     onPurchase: () => void;
//     isLoading: boolean;
// }

// const Hero: React.FC<HeroProps> = ({ onPurchase, isLoading }) => {
//     return (
//         <section className="bg-black text-white pt-16 pb-4 px-4">
//             <div className="max-w-4xl mx-auto text-center">

//                 {/* Launch Badge */}
//                 <div className="inline-block bg-zinc-900 border border-cyan-400 rounded-full px-4 py-2 mb-6">
//                     <span className="text-cyan-400 text-xs font-semibold uppercase tracking-wide">
//                         🚀 Launch offer · $9.99 · 79% OFF
//                     </span>
//                 </div>

//                 {/* Title */}
//                 <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight max-w-2xl mx-auto">
//                     Grow on X faster
//                     <span className="text-cyan-400"> and get users for your SaaS</span>
//                 </h1>

//                 {/* Subheadline */}
//                 <p className="text-sm md:text-base text-gray-300 mb-8 max-w-2xl mx-auto">
//                     A 45-page, no-fluff PDF with the exact system used to go from 0 to 15k followers in 10 months,
//                     bring real users to SaaS products, and land paid collabs.
//                 </p>

//                 {/* Photo + Intro */}
//                 <div className="flex flex-col md:flex-row items-center justify-center gap-5 mb-10">
//                     <img
//                         src="/images/eliana-boat-3.png"
//                         alt="Eliana photo"
//                         className="w-28 h-28 md:w-32 md:h-32 object-cover rounded-full border border-cyan-400 shadow-md"
//                     />

//                     <p className="text-sm leading-relaxed text-gray-300 max-w-sm text-center md:text-left">
//                         <strong>Hey, I'm Eliana.</strong> Scuba instructor turned indie hacker.
//                         I grew <strong>0 → 15k followers in 10 months</strong> while building SaaS apps.
//                         No verification. No gimmicks.
//                     </p>
//                 </div>

//                 {/* CTA */}
//                 <button
//                     onClick={onPurchase}
//                     disabled={isLoading}
//                     className={`bg-cyan-400 hover:bg-cyan-300 text-black font-semibold py-3 px-10 rounded-lg text-lg transition-transform hover:scale-105 ${isLoading ? "opacity-60 cursor-not-allowed hover:scale-100" : ""
//                         }`}
//                 >
//                     {isLoading ? "Processing..." : "Get the PDF for $9.99"}
//                 </button>

//                 <p className="text-xs text-gray-400 mt-3 mb-10">
//                     <s className="text-gray-500">$29.99</s> · Instant download · 45 pages of playbooks, hooks and examples.
//                 </p>

//                 {/* Sales Copy */}
//                 <div className="max-w-2xl mx-auto text-gray-300 text-sm leading-relaxed space-y-4 text-left">
//                     <h2 className="text-2xl md:text-3xl font-bold mb-4 leading-tight pt-6">
//                         0 → 15k followers in 10 months
//                     </h2>
//                     <p>
//                         10 months ago, there was no audience, no users, and no revenue.
//                         Now there are 15k followers, consistent SaaS signups, and brands paying for collabs.
//                     </p>

//                     <p>
//                         Inside, you get the exact growth system:
//                         <strong> hooks, viral examples, content formulas, and tactics to turn reach into users and revenue</strong>.
//                         If you are building a product and trying to grow on X,
//                         this PDF will save you months of guessing and experimentation.
//                     </p>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default Hero;